var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 7.7C20.2 6.73 19.44 6.07 17.91 4.76L16.49 3.54C13.74 1.19 12.35 0 10.55 0C8.75 0 7.36 1.19 4.61 3.55L3.19 4.77C1.66 6.08 0.9 6.73 0.45 7.7C0 8.67 0 9.68 0 11.7V17.71C0 20.55 0 21.98 1.01 22.99C2.03 24.01 3.45 24.01 6.29 24.01H14.79C17.63 24.01 19.06 24.01 20.07 22.99C21.09 21.97 21.09 20.55 21.09 17.71V11.7C21.09 9.69 21.09 8.68 20.64 7.7H20.65ZM13.46 22.74H7.64V16.29C7.64 15.86 7.99 15.51 8.43 15.51H12.68C13.11 15.51 13.47 15.86 13.47 16.29V22.74H13.46Z",
    fill: "#028383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActiveIcon);
export default __webpack_public_path__ + "static/media/homeActiveIcon.626efddb4d944e37dc76e39eb958cb25.svg";
export { ForwardRef as ReactComponent };